import { render } from "./ButtonCircle.vue?vue&type=template&id=35a109ca&lang=true"
import script from "./ButtonCircle.vue?vue&type=script&lang=js"
export * from "./ButtonCircle.vue?vue&type=script&lang=js"
script.render = render

export default script